import { InputNumber as AntInputNumber } from 'antd';
import { InputNumberProps as AntInputNumberProps } from 'antd/lib/input-number';

export type NumberProps = {
  defaultValue?: number;
  value?: number;
  autoFocus: boolean;
  disabled: boolean;
  readOnly: boolean;
  max?: number;
  min?: number;
  formatter?: (value?: string | number) => string;
  size: 'large' | 'middle' | 'small';
  step?: number | string;
  onChange?: (value: number | string | undefined) => void;
  onPressEnter?: () => void;
  parser?: (displayValue: string | undefined) => number | string;
};

const Number = (props: NumberProps & AntInputNumberProps) => {
  const { className } = props;
  const classNames = [className, 'input', 'number'];
  return <AntInputNumber {...props} className={classNames.join(' ')} />;
};

Number.defaultProps = {
  autoFocus: false,
  disabled: false,
  readOnly: false,
  size: 'middle',
};

export default Number;
